// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataCacheToolRayType, DataCacheToolToolType } from "../DataCacheToolEnums.js";
import { Color } from "../../../Commons/Graphics.js";
import { DataCacheTool } from "../DataCacheTool.js";
import { DynProperty, ColorStyleWidth } from "../../DynProperty.js";

export let PriceChannelDataCacheTool = function ()
{
    DataCacheTool.apply(this);
    this.ToolType = DataCacheToolToolType.PriceChannel;
    this.InitPoints(3);
};

PriceChannelDataCacheTool.prototype = Object.create(DataCacheTool.prototype);

PriceChannelDataCacheTool.prototype.MinPointsCount = function () { return 3; };
PriceChannelDataCacheTool.prototype.MaxPointsCount = function () { return 3; };

//#region ICaller

PriceChannelDataCacheTool.prototype.Properties = function ()
{
    var props = DataCacheTool.prototype.Properties.apply(this);

    var prop = new DynProperty(
        "Left ray",
        this.RayType === DataCacheToolRayType.LeftRay || this.RayType === DataCacheToolRayType.DoubleRay,
        DynProperty.BOOLEAN,
        DynProperty.VISUAL_GROUP);

    prop.sortIndex = 0;
    props.push(prop);

    var prop = new DynProperty(
        "Right ray",
        this.RayType === DataCacheToolRayType.RightRay || this.RayType === DataCacheToolRayType.DoubleRay,
        DynProperty.BOOLEAN,
        DynProperty.VISUAL_GROUP);

    prop.sortIndex = 1;
    props.push(prop);

    var colorStyleWidthRays = new ColorStyleWidth(Color.Empty, this.styleRay, 1);
    colorStyleWidthRays.enableStyleOnly();
    props.push(new DynProperty(
        "Ray style",
       colorStyleWidthRays,
        DynProperty.COLOR_STYLE_WIDTH,
        DynProperty.VISUAL_GROUP));

    return props;
};

PriceChannelDataCacheTool.prototype.callBack = function (properties)
{
    DataCacheTool.prototype.callBack.call(this, properties);

    var prop = DynProperty.getPropertyByName(properties, "Ray style");
    if (prop) this.StyleRay = prop.value.Style;

    this.RayType = DataCacheTool.GetRayType(properties);
};

//#endregion